import {ActivatedRoute, Router} from '@angular/router';
import {Component, inject, OnInit} from '@angular/core';
import {BAVEL_PATH, EXTRANET_KEYS} from '@config/app-config';
import {IUserProfileInfo} from '@shared/interfaces/user-profile-info.interface';
import {LocalStorageService} from '@shared/services/local-storage.service';
import {AuthService, ROLES} from "@account/services/auth.service";

@Component({
    selector: 'bv-tool-main',
    templateUrl: './tool-main.component.html',
    styleUrls: ['./tool-main.component.scss'],
    standalone: false
})
export class ToolMainComponent implements OnInit {
  public userProfile: IUserProfileInfo | undefined;
  public showRenovatingPopup = false;

  private router: Router = inject(Router);
  private authService = inject(AuthService);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private localStorageService: LocalStorageService = inject(LocalStorageService);

  public ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.userProfile = data['userProfile'];
    });

    this.showRenovatingPopup = this.localStorageService.get(EXTRANET_KEYS.SHOW_RENOVATING_POPUP) !== false;

    this.redirectUserByRole();
  }

  private redirectUserByRole() {
    const userRole = this.authService.userRole();
    switch (userRole) {
      case ROLES.FN_EPAYMENTS_SUPPLIER:
        this.router.navigate([BAVEL_PATH.BAVEL_COLLECT_TRAVEL]);
        break;
      case ROLES.EPAYMENTS_CLIENT_TRAVEL:
        this.router.navigate([BAVEL_PATH.BAVELPAY_TRAVEL]);
        break;
    }
  }
}
